import MetaUsuario from './MetaUsuario';

export default MetaUsuario;